import { IPermission } from '@models';
import { Action } from 'redux';

export enum AuthenticationStatus {
  none,
  anonymous,
  authenticating,
  authenticated,
  failed,
}

export interface AuthenticationState {
  status: AuthenticationStatus;
  user?: User;
  error?: string;
}

export interface CredentialsProps {
  username: string;
  password: string;
}

export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGING_IN = 'LOGGING_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const LOG_IN_FAILED = 'LOG_IN_FAILED';

export interface ILoggingInAction extends Action {
  type: typeof LOGGING_IN;
}

export interface ILoggedInAction extends Action {
  type: typeof LOGGED_IN;
  payload: User;
}

export interface ILoggedOutAction extends Action {
  type: typeof LOGGED_OUT;
  payload: any;
}

export interface ILoggedInFailed extends Action {
  type: typeof LOG_IN_FAILED;
  payload: string;
}

export type AuthenticateActionTypes =
  | ILoggingInAction
  | ILoggedOutAction
  | ILoggedInAction
  | ILoggedInFailed;

export interface User {
  firstName: string;
  lastName: string;
  email: string;
  hasValidTOS?: boolean;
  institution?: string;
  accountId?: string;
  adaptiveSuperUser: boolean;
  permissions: IPermission[];
}
